import React from "react";
import { Button, Input } from "@showitinc/showit-wc";

import ButtonBar from "../base/ButtonBar";
import uiPrefix from "../../utils/UiPrefixUtils";

class FolderNameDialog extends React.Component {
  static defaultProps = {
    submitting: false,
    error: null,
    placeholder: "",
    label: "Name",
    title: "Update Name",
    actionLabel: "OK",
    cancelLabel: "Cancel",
    width: 400,
  };

  constructor(props) {
    super(props);

    let name = "";
    if (props.name) {
      name = props.name;
    }

    this.state = {
      name,
    };
  }

  componentDidMount() {
    this._input.focus();
  }

  _submit = () => {
    if (this.props.onNameUpdate) {
      let name = this.state.name.trim();
      this.props.onNameUpdate({ name });
    }
  };

  _onNameChange = (e) => {
    let value = e.target.value;
    this.setState({ name: value });
  };

  _onKeyPress = (e) => {
    if (e && e.key === "Enter") {
      this._submit();
    }
  };

  render() {
    let error = this.props.error;
    let errorMessage = null;

    if (error) {
      errorMessage = (
        <div className="has-error">
          <div className="help-block">{error.message}</div>
        </div>
      );
    }

    return (
      <div className="si-dialog" style={{ width: this.props.width }}>
        <div className="si-dialog-header">{this.props.title}</div>
        <div style={{ padding: 20 }}>
          <div style={{ display: "flex", alignContent: "stretch", justifyContent: "flex-end" }}>
            <Input
              type="text"
              longLabel
              label={this.props.label}
              ref={(c) => (this._input = c)}
              style={{ flexGrow: 3 }}
              name="name"
              data-testid="folder-name-input"
              placeholder={this.props.placeholder}
              value={this.state.name}
              onSIInput={this._onNameChange}
              onSIKeyPress={this._onKeyPress}
            />
          </div>
          {errorMessage}
          <ButtonBar align="space-between" style={{ paddingTop: 10 }}>
            <Button
              data-e2e={uiPrefix("modal-cancel-btn")}
              className={uiPrefix("modal-cancel-btn")}
              onClick={this.props.onCancel}
              variant="minimal"
              disabled={this.props.submitting}
            >
              {this.props.cancelLabel}
            </Button>
            <Button
              data-e2e={uiPrefix("modal-save-btn")}
              className={uiPrefix("modal-save-btn")}
              onClick={this._submit}
              variant="feature"
              disabled={this.props.submitting || this.state.name.trim() === ""}
            >
              {this.props.actionLabel}
            </Button>
          </ButtonBar>
        </div>
      </div>
    );
  }
}

export default FolderNameDialog;
